import Papa from 'papaparse';

export interface CsvPreview {
  headers: string[];
  sampleRows: Record<string, string>[];
  delimiter: string;
  encoding: string;
  encodingWarning?: string;
}

export async function extractCsvPreview(file: File, maxRows = 5): Promise<CsvPreview> {
  const chunk = file.slice(0, 102400); // First ~100KB

  let text: string;
  let encoding = 'utf-8';
  let encodingWarning: string | undefined;
  try {
    text = await chunk.text();
    if (text.includes('\uFFFD')) throw new Error('Invalid UTF-8');
  } catch {
    const buffer = await chunk.arrayBuffer();
    text = new TextDecoder('latin1').decode(buffer);
    encoding = 'latin1';
    encodingWarning = 'File appears to use Latin-1 encoding. Headers may display differently than expected.';
  }

  const result = Papa.parse(text, { header: true, preview: maxRows, skipEmptyLines: true });
  return {
    headers: result.meta.fields ?? [],
    sampleRows: result.data as Record<string, string>[],
    delimiter: result.meta.delimiter,
    encoding,
    encodingWarning,
  };
}
